import { ProgressBar } from '@fluentui/react-components';
import type { ReviewProgress } from '../api';
import { getDocumentType } from '../officeApi';

const PHASE_LABEL: Record<ReviewProgress['phase'], string> = {
  queued: 'Queued…',
  deterministic: 'Running rule-based checks…',
  judgment: 'Running AI QC…',
  writing_comments: 'Writing comments into the document…',
  done: 'Done',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export function RunProgress({ progress }: { progress: ReviewProgress }) {
  const value = progress.totalSlides > 0 ? progress.slidesProcessed / progress.totalSlides : undefined;
  // The run only reports its unit label once the file is parsed; until then go by the open app.
  const isWord = (progress.documentType ?? getDocumentType()) === 'docx';
  const unit = progress.unitLabel ?? (isWord ? 'page' : 'slide');
  const phaseLabel = progress.phase === 'writing_comments' && !isWord ? 'Writing comments into the deck…' : PHASE_LABEL[progress.phase];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div>{phaseLabel}</div>
      {progress.phase === 'judgment' && (
        <>
          <ProgressBar value={value} />
          <div style={{ fontSize: 12, color: '#666' }}>
            Scanned {progress.slidesProcessed} of {progress.totalSlides} {unit}s
          </div>
        </>
      )}
      <div style={{ fontSize: 12, color: '#666' }}>{progress.issuesFoundSoFar} issue(s) found so far</div>
      {progress.error && <div style={{ color: '#b91c1c' }}>{progress.error}</div>}
    </div>
  );
}
